import classNames from "classnames";

import { ButtonChangeCart } from "features/Dashboard/ButtonChangeCart";
import { priceFormat } from "utils/format";
import { ChangeProviderCart } from "../ChangeProviderCart";

import { CutLink } from "components/CutLink";

export const getTableColumns = (openNomenclatureModal) => [
  {
    dataField: "brand",
    text: "Бренд",
    formatter: (cell, row) => <CutLink
      onClick={() => openNomenclatureModal(row.nomenclature)}
      nomenclature={{ ...row, id: row.nomenclature }}
    >
      {row.brand}
    </CutLink >,
    headerStyle: (colum, colIndex) => {
      return { width: "13%" };
    },
    footer: () => null,
    editable: false,
  },
  {
    dataField: "article",
    text: "Артикул",
    formatter: (cell, row) => <CutLink
      onClick={() => openNomenclatureModal(row.nomenclature)}
      nomenclature={{ ...row, id: row.nomenclature }}
    >
      {row.article}
    </CutLink>,
    headerStyle: (colum, colIndex) => {
      return { width: "13%" };
    },
    footer: () => null,
    editable: false,
  },
  {
    dataField: "name",
    text: "Наименование",
    headerStyle: (colum, colIndex) => {
      return { width: "27%" };
    },
    formatter: (cell, row) => <CutLink
      onClick={() => openNomenclatureModal(row.nomenclature)}
      nomenclature={{ ...row, id: row.nomenclature }}
    >
      {row.name}
    </CutLink>,
    footer: () => null,
    editable: false,
  },
  {
    dataField: "price",
    text: "Цена",
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "6%" };
    },
    formatter: (cell, row) => priceFormat(cell),
    classes: (cell, row, rowIndex, colIndex) => "editable right",
    headerClasses: () => "right",
    footerClasses: () => "right",
    footer: () => null,
  },
  {
    dataField: "count",
    text: "Кол.",
    headerStyle: (colum, colIndex) => {
      return { width: "5%" };
    },
    classes: () => "right",
    headerClasses: () => "right",
    footerClasses: () => "right",
    footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0),
    editable: false,
  },
  {
    dataField: "summ",
    text: "Сумма",
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "6%" };
    },
    formatter: (cell, row) => priceFormat(cell),
    classes: () => "right",
    headerClasses: () => "right",
    footerClasses: () => "right",
    footer: (columnData) => {
      const total = columnData.reduce((acc, item) => acc + parseFloat(item), 0);
      return total && priceFormat(total);
    },
    editable: false,
  },
  {
    dataField: "exist",
    text: "Нал.",
    headerStyle: (colum, colIndex) => {
      return { width: "6%" };
    },
    classes: (cell, row, rowIndex, colIndex) => "right",
    headerClasses: () => "right",
    footerClasses: () => "right",
    footer: () => null,
    editable: false,
  },
  {
    dataField: "provider",
    text: "Поставщик",
    headerStyle: (colum, colIndex) => {
      return { width: "12%" };
    },
    classes: (cell) => (!cell?.id ? "cart__error" : ""),
    formatter: (cell, row) => <ChangeProviderCart row={row} />,
    footer: () => null,
    editable: false,
  },
  {
    dataField: "warehouse",
    text: "Склад",
    headerStyle: (colum, colIndex) => {
      return { width: "9%" };
    },
    formatter: (cell) => <span className="cute">{cell?.name}</span>,
    classes: (cell) => classNames({ "green-bg": cell }),
    footer: () => null,
    editable: false,
  },
  {
    dataField: "action",
    text: "Действия",
    headerStyle: (colum, colIndex) => {
      return { width: "152px" };
    },
    formatter: (_, row) => <ButtonChangeCart row={row} />,
    footer: () => null,
    editable: false,
  },
];
